import { Row } from "react-bootstrap";
import styled from "styled-components";

const FormRow = styled(Row)`
margin-top: 20px;
margin-bottom: 20px;
`;

export default FormRow